import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProviders } from '@/app/providers';
import { RouterProvider } from 'react-router-dom';
import { router } from './app/router';
import { EnvironmentBanner } from '@/shared/layouts/EnvironmentBanner';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <EnvironmentBanner environment={import.meta.env.VITE_APP_ENV} />
        <AppProviders>
            <RouterProvider router={router} />
        </AppProviders>
    </React.StrictMode>
);
